export interface IApiRequest {
    url: string;
    requestId?: string;
    data?: any;
    message?: string;
}

export class ApiRequest implements IApiRequest {
    readonly url: string;
    readonly requestId?: string;
    readonly data?: any;
    readonly message?: string;

    constructor(url: string, requestId?: string, data?: any, message?: string) {
        this.url = url;
        this.requestId = requestId;
        this.data = data;
        this.message = message;
    }
}